//for tmotions

export const tmAIAssistantDefaultValue = {
  tmAIChatbotPrimaryColor: '#F50537',
  tmAIChatbotHeaderTitle: 'Ruby',
  tmAIChatbotAvtar: '',
  tmAIChatbotFontFamily: 'Arial, sans-serif',
  tmAIChatbotApiUrl: 'https://rnib-api-uat.tglserver.net/',
  tmAIChatbotFEUrl: 'https://rnib-ui-uat.tglserver.net/',
  chatHistoryLoadMsg: 'We are restoring your previous history......',
  userId: '123',
  WELCOME_MESSAGE: "Hello and welcome to our Travel and Technology Learning Resources. My name is Ruby and I am RNIBs digital learning advisor. These learning resources focus on enhancing awareness, knowledge and skills around technology, travel, and wellbeing. In order to create a tailored learning pathway for you, I’d like to start by asking a few questions to understand how I can best support you today with your tech, transport or travel learning requirements. Are you happy to continue?",
  TITLE: 'Ruby',
};

// Set a session storage item
export const setSession = (name, value) => {
  sessionStorage.setItem(name, value);
};

// Get a session storage item
export const getSession = (name) => {
  return sessionStorage.getItem(name); // returns null if not found
};
